var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Card } from "@irati/ui/src/Layout";
import Icon from "@irati/ui/src/Icon";
import { greys } from "@irati/ui/src/global/colors";
import FlexWrapper from "../../ui/Layout/FlexWrapper";
import { Para } from "../../ui/Labels";
var StyledCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 25px;\n  margin-bottom: 15px;\n  padding: 10px;\n  position: relative;\n  cursor: pointer;\n"], ["\n  margin-top: 25px;\n  margin-bottom: 15px;\n  padding: 10px;\n  position: relative;\n  cursor: pointer;\n"])));
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: -15px;\n  margin-left: calc(50% - 25px);\n  background: ", ";\n  height: 50px;\n  width:50px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  top: -15px;\n  margin-left: calc(50% - 25px);\n  background: ", ";\n  height: 50px;\n  width:50px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), greys.light);
var Expander = function (_a) {
    var onClick = _a.onClick, count = _a.count;
    return (React.createElement(StyledCard, { onClick: onClick, small: true },
        React.createElement(IconWrapper, null,
            " ",
            React.createElement(FlexWrapper, null,
                React.createElement(Icon, { icon: "comment", size: 20 }),
                React.createElement(Para, { medium: true, flush: true }, count)),
            " ")));
};
export default Expander;
var templateObject_1, templateObject_2;
